import { HttpResponse } from '@angular/common/http';
import { InjectableApi } from '@shared/decorators';
import { ApiService } from '@shared/services';
import { ForceAny } from '@shared/types';
import { Observable } from 'rxjs';

export interface LoginCredentials {
  username: string;
  password: string;
}

@InjectableApi({
  baseSegment: 'ats/auth',
})
export class LoginService extends ApiService {
  login(credentials: LoginCredentials): Observable<HttpResponse<ForceAny>> {
    return this.headersPostRequest('/login', credentials);
  }
}
